export const SET_NOTIFICATION_DIALOG = 'SET_NOTIFICATION_DIALOG';
export const CLOSE_NOTIFICATION_DIALOG = 'CLOSE_NOTIFICATION_DIALOG';
export const CLOSE_ALL_NOTIFICATION_DIALOG = 'CLOSE_ALL_NOTIFICATION_DIALOG';
export const ADD_NOTIFICATION_DIALOGS = 'ADD_NOTIFICATION_DIALOGS';
export const SET_YES_NO_DIALOG_PROPS = 'SET_YES_NO_DIALOG_PROPS';
export const RESET_YES_NO_DIALOG_PROPS = 'RESET_YES_NO_DIALOG_PROPS';



// WEBPACK FOOTER //
// ./src/components/dialogs/state/types.js